import React from 'react';

interface Props {
    variant: 'confirm' | 'success';
    onClose: () => void;
    onYes?: () => void;
    onNo?: () => void;
}

const LocationCreated: React.FC<Props> = ({ variant, onClose, onYes, onNo }) => {
    return (
        <div className="lc-modal-overlay">
            <div className="lc-modal">
                <button className="lc-modal__close" onClick={onClose}>
                    <img src='/assets/images/dismiss.svg' alt='close' />
                </button>

                {/* Badge icon */}
                <div className="lc-modal__icon">
                    <img src='/assets/images/badge-check.svg' alt='location created' />
                </div>

                <h2 className="lc-modal__title">{variant === 'confirm' ? 'Add Location' : 'Location Created'}</h2>

                {variant === 'confirm' ? (
                    <>
                        <p className="lc-modal__desc">
                            Do you want to add location to the 6th Degree location studio vault?
                        </p>
                        <div className="lc-modal__buttons">
                            <button className="lc-modal__btn lc-modal__btn--secondary" onClick={onYes}>
                                Yes, Add Location
                            </button>
                            <button className="lc-modal__btn lc-modal__btn--primary" onClick={onNo}>
                                No, Don't Add
                            </button>
                        </div>
                    </>
                ) : (
                    <p className="lc-modal__desc">Location successfully created.</p>
                )}
            </div>
        </div>
    );
};

export default LocationCreated;